import { Fragment, ReactNode } from "react";
import AdminRegionLayout from "../../components/AdminRegionSpace/AdminRegionLayout/AdminRegionLayout";

function AdminRegionSpace() {
    return <Fragment></Fragment>;
}

AdminRegionSpace.getLayout = (page: ReactNode) => (
    <AdminRegionLayout>{page}</AdminRegionLayout>
);

export default AdminRegionSpace;
